import Info from '@components/Info'
import { Pricing, PricingOptionB, PricingOptionWrap, PricingToggle } from '@components/Pricing'
import PricingPlan from '@components/Pricing/atoms/Plan'
import Section, { SectionHeadline } from '@components/Section'
import Container from '@components/UI/Container'
import Icon from '@components/UI/Icon'
import Link from '@components/UI/Link'
import Heading from '@components/UI/Typography/Heading'
import Paragraph from '@components/UI/Typography/Paragraph'
import { PRICE_PLANS } from "./plansData"
import { PAYMENT_PLANS } from "./paymentPlansData"

import { useCallback } from 'react'
import { twJoin, twMerge } from 'tailwind-merge';

export default ({ paymentPlan }) => {
  const smoothScrollToFeaturesTable = useCallback((event) => {
    event.preventDefault()

    document.querySelector('#features-table')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }, [])

  return (
    <Section
      mods={{
        'bg-neutral2': 900,
        pricing: true
      }}
    >
      <Container className="1280:(px-[5rem])">
        <SectionHeadline
          mods={{ center: true, mode: 'b' }}
          className={"pt-12"}
        >
          <div
            className={twJoin(
              "absolute",
              "w-full",
              "mx-auto",
              "max-w-[1280px]",
              "h-[200px]",
              "left-[50%]",
              "translate-x-[-50%]",
              "blur-[160px]",
              "bg-[linear-gradient(95.96deg,_rgba(141,_110,_255,_0.3)_0%,_rgba(232,_57,_255,_0.3)_100.43%)]"
            )}
          />
          <Heading
            tag='h1'
            color='white'
          >
            Traqq pricing
          </Heading>

          <Paragraph
            tag='p'
            color='white'
            mods={{ lg: true }}
          >
            Try any plan free. No credit card required.
          </Paragraph>
        </SectionHeadline>

        <Pricing mods={{ mode: 'b' }}>
          <PricingToggle
            plans={PAYMENT_PLANS}
            mods={{ 'css-pointer': true }}
          />

          <div className="flex flex-col gap-y-3 xl:flex-row xl:gap-y-0">
            {PRICE_PLANS.map(((plan, index) => (
              <>
                <PricingOptionWrap
                  // TODO: rewrite without useAtom (!!)
                  className={
                    // paymentPlan !== undefined guard to avoid flicker on first render
                    plan.recommended && paymentPlan !== undefined
                      ? "pb-2 px-2 flex-col rounded-lg bg-slate-blue-500"
                      : undefined
                  }
                  recommended={plan.recommended}
                  mods={{ loading: !paymentPlan }}
                  paymentPlan={paymentPlan}
                >
                  <PricingOptionB
                    enterprise={plan.key === "enterprise"}
                    recommended={plan.recommended}
                    plans={PAYMENT_PLANS}
                    pricePlan={plan}
                    currentPlan={paymentPlan}
                    className={twMerge(
                      "rounded-xl xl:rounded-none",
                      index === 0 && "xl:rounded-l-xl",
                      index === PRICE_PLANS.length - 1 && "xl:rounded-r-xl",
                      plan.recommended && "xl:rounded-xl"
                    )}
                  />
                </PricingOptionWrap>
              </>
            )))}
          </div>

          <Info
            mods={{ center: true }}
            gap={2}
          >
            <Paragraph
              tag='p'
              size='sm'
              color='neutral_300'
              className={"flex items-center"}
            >
              <Icon
                name='shield2'
                color='neutral-300'
                size={16}
              />

              <span>Subscription can be canceled anytime</span>
            </Paragraph>
            <Paragraph
              tag='p'
              size='sm'
              color='neutral_300'
              className={"flex items-center"}
            >
              <span>14-day money-back guarantee</span>
            </Paragraph>
          </Info>
          <Link
            href="#features-table"
            onClick={smoothScrollToFeaturesTable}
            className={twJoin(
              "pt-[22px] w-fit justify-self-center",
              "flex items-center justify-center gap-2",
              "group",
              "text-slate-blue-300 hover:text-slate-blue-200",
              "text-sm whitespace-nowrap"
            )}
          >
            <Icon
              // changing icon color on hover too
              // transition
              className={twJoin(
                "[&_path]:fill-slate-blue-300",
                "[&_path]:transition-colors [&_path]:duration-200",
                "group-hover:[&_path]:fill-slate-blue-200"
              )}
              name='arrow-down'
              color='#'
              size={16}
            />
            Compare plan features
          </Link>
        </Pricing>
      </Container>
    </Section>
  )
}
